<template>
  <div class="rel">
    <v-btn class="absolute-close" depressed dark large color="spiceRed" @click="closeModal">
      <v-icon>close</v-icon>
    </v-btn>
    <v-card class="white">
      <v-toolbar fixed v-if="false" color="white" class="elevation-1">
        <v-toolbar-title class="d-flex logo-inner">
          <img :src="require('@/assets/images/spice-logo.png')" width="200px" alt="Spice Logo">
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <ul class="nav-listing">
          <li>
            <a href title>About Us</a>
          </li>
          <li>
            <a href title>Our Teams</a>
          </li>
          <li>
            <a href title>Join Now</a>
          </li>
          <li>
            <a href title>Contact Us</a>
          </li>
        </ul>
        <v-btn icon fab @click="closeModal">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="inner-content mt-2">
        <h1 class="title pb-3">
          Job /
          <span>Opportunities</span>
        </h1>

        <v-layout row wrap>
          <v-flex md7 xs12>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed enim mauris, luctus a justo sed, viverra bibendum nisl. Pellentesque facilisis dolor eget facilisis consequat. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. In ultricies, ligula vel eleifend tristique, justo massa scelerisque sapien, eu dictum risus leo in nisi. Morbi odio ante, sollicitudin sed finibus vel, bibendum id magna. Phasellus suscipit fringilla neque, id sollicitudin odio tincidunt ac. Curabitur vel interdum neque. Sed ornare mi diam, at placerat leo mattis quis. Duis rutrum elit nisi, quis pharetra leo maximus non. In hac habitasse platea dictumst. Sed maximus leo est, nec accumsan tellus fringilla a. Nulla tincidunt dui imperdiet ultrices porttitor. Pellentesque ut vestibulum neque, et malesuada nibh. Pellentesque mi dui, gravida et gravida at, accumsan nec lorem. Nunc id lacinia urna. Sed sed arcu justo.</p>

            <p>Click/Hover the icons below to explore our solutions.</p>

            <ul class="icon-triggers">
              <li
                :class="apis?'active':''"
                @click="alliancePartners=false; apis=true; "
                @mouseover="alliancePartners=false; apis=true; "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Capa_1"
                  x="0px"
                  y="0px"
                  viewBox="0 0 380 380"
                  style="enable-background:new 0 0 380 380;"
                  xml:space="preserve"
                  width="100%"
                  height="100%"
                >
                  <path
                    d="M91.425,157.435c-1.065-2.297-3.366-3.767-5.897-3.767c-0.005,0-0.01,0-0.015,0c-2.537,0.006-4.839,1.487-5.895,3.794   L47.402,227.83c-1.494,3.264-0.06,7.122,3.204,8.616c0.877,0.401,1.797,0.591,2.702,0.591c2.464,0,4.821-1.409,5.914-3.796   l8.08-17.649h36.75l8.193,17.677c1.51,3.257,5.373,4.674,8.631,3.164c3.257-1.51,4.673-5.374,3.164-8.631L91.425,157.435z    M73.254,202.592l12.311-26.888l12.462,26.888H73.254z"
                    fill="#FFFFFF"
                  ></path>
                  <path
                    d="M166.496,152.865H135.07c-3.59,0-6.5,2.91-6.5,6.5v71.17c0,3.59,2.91,6.5,6.5,6.5c3.59,0,6.5-2.91,6.5-6.5V203.5h24.926   c13.96,0,25.316-11.357,25.316-25.316C191.813,164.223,180.456,152.865,166.496,152.865z M166.496,190.5H141.57v-24.635h24.926   c6.792,0,12.316,5.526,12.316,12.318C178.813,184.975,173.288,190.5,166.496,190.5z"
                    fill="#FFFFFF"
                  ></path>
                  <path
                    d="M203.313,152.865c-3.59,0-6.5,2.91-6.5,6.5v71.17c0,3.59,2.91,6.5,6.5,6.5s6.5-2.91,6.5-6.5v-71.17   C209.813,155.775,206.902,152.865,203.313,152.865z"
                    fill="#FFFFFF"
                  ></path>
                  <path
                    d="M368.317,46.487H11.684C5.241,46.487,0,51.73,0,58.173v263.656c0,6.442,5.241,11.684,11.684,11.684h356.634   c6.442,0,11.683-5.242,11.683-11.684V58.173C380,51.73,374.76,46.487,368.317,46.487z M280.949,259.268   c5.162-12.192,17.053-20.07,30.295-20.07c4.411,0,8.721,0.878,12.813,2.61c16.696,7.072,24.529,26.408,17.461,43.105   c-5.167,12.191-17.058,20.068-30.294,20.068c0,0,0,0-0.001,0c-4.411,0-8.721-0.878-12.81-2.611   c-8.089-3.424-14.361-9.793-17.659-17.935C277.455,276.294,277.524,267.356,280.949,259.268z M320.868,79.771   c6.844,0,12.387,5.547,12.387,12.387c0,6.842-5.543,12.387-12.387,12.387c-6.839,0-12.385-5.545-12.385-12.387   C308.483,85.318,314.029,79.771,320.868,79.771z M283.715,79.771c6.839,0,12.386,5.547,12.386,12.387   c0,6.842-5.547,12.387-12.386,12.387c-6.839,0-12.387-5.545-12.387-12.387C271.328,85.318,276.876,79.771,283.715,79.771z    M246.561,79.771c6.839,0,12.381,5.547,12.381,12.387c0,6.842-5.542,12.387-12.381,12.387c-6.844,0-12.387-5.545-12.387-12.387   C234.175,85.318,239.718,79.771,246.561,79.771z M21.27,314.01V141.424H358.73v67.274c-1.537-2.202-3.677-4.02-6.327-5.143   l-20.614-8.726c-1.835-0.778-3.771-1.172-5.754-1.172c-5.956,0-11.303,3.54-13.623,9.02l-1.253,2.959   c-9.227,0.129-18.381,2.255-26.728,6.193l-2.426-2.107c-1.174-1.018-2.499-1.841-3.932-2.447c-1.841-0.779-3.782-1.174-5.771-1.174   c-4.276,0-8.341,1.858-11.154,5.099l-14.671,16.915c-2.583,2.986-3.855,6.794-3.581,10.735c0.285,3.941,2.084,7.535,5.064,10.115   l2.417,2.098c-2.755,8.849-3.563,18.179-2.365,27.344l-2.749,1.654c-6.981,4.2-9.242,13.302-5.039,20.293L249.044,315H22.26   C21.714,315,21.27,314.556,21.27,314.01z"
                    fill="#FFFFFF"
                  ></path>
                </svg>
              </li>

              <li
                :class="alliancePartners?'active':''"
                @click="alliancePartners=true; apis=false; "
                @mouseover="alliancePartners=true; apis=false;"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Capa_1"
                  x="0px"
                  y="0px"
                  viewBox="0 0 512 512"
                  style="enable-background:new 0 0 512 512;"
                  xml:space="preserve"
                  width="100%"
                  height="100%"
                >
                  <path
                    d="M103.035,410.484c6.844-8.387,10.958-19.085,10.958-30.729c0-26.844-21.839-48.683-48.683-48.683    s-48.683,21.839-48.683,48.683c0,11.644,4.114,22.343,10.958,30.729C10.911,422.33,0,441.782,0,463.748V512h130.622v-48.252    C130.622,441.782,119.71,422.329,103.035,410.484z"
                    fill="#FFFFFF"
                  ></path>
                  <path
                    d="M293.725,79.412c6.844-8.387,10.958-19.085,10.958-30.729C304.683,21.839,282.844,0,256,0s-48.683,21.839-48.683,48.683    c0,11.644,4.114,22.343,10.958,30.729c-16.675,11.845-27.586,31.298-27.586,53.264v48.252H321.31v-48.252h0.001    C321.311,110.71,310.4,91.258,293.725,79.412z"
                    fill="#FFFFFF"
                  ></path>
                  <path
                    d="M484.414,410.485c6.845-8.387,10.958-19.085,10.958-30.73c0-26.844-21.839-48.683-48.683-48.683    s-48.683,21.839-48.683,48.683c0,11.644,4.114,22.343,10.958,30.729c-16.675,11.845-27.587,31.298-27.587,53.264V512H512v-48.252    C512,441.782,501.089,422.33,484.414,410.485z"
                    fill="#FFFFFF"
                  ></path>
                  <path
                    d="M144.042,210.976v170.112h70.934L256,417.899l41.024-36.812h70.934V210.976H144.042z M307.922,311.032H204.078v-30    h103.844V311.032z"
                    fill="#FFFFFF"
                  ></path>
                </svg>
              </li>
            </ul>
          </v-flex>

          <v-flex md5 xs12 class="text-xs-center">
            <img :src="require('@/assets/images/career.jpg')" alt="spice money" width="90%">
          </v-flex>
        </v-layout>
        <transition name="fadeY" mode="out-in">
          <v-layout row wrap py-5 v-if="apis">
            <v-flex xs12>
              <h2>Our Own Apis</h2>
            </v-flex>
            <v-flex md12 xs12>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed enim mauris, luctus a justo sed, viverra bibendum nisl. Pellentesque facilisis dolor eget facilisis consequat. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. In ultricies, ligula vel eleifend tristique, justo massa scelerisque sapien, eu dictum risus leo in nisi. Morbi odio ante, sollicitudin sed finibus vel, bibendum id magna. Phasellus suscipit fringilla neque, id sollicitudin odio tincidunt ac. Curabitur vel interdum neque. Sed ornare mi diam, at placerat leo mattis quis. Duis rutrum elit nisi, quis pharetra leo maximus non. In hac habitasse platea dictumst. Sed maximus leo est, nec accumsan tellus fringilla a. Nulla tincidunt dui imperdiet ultrices porttitor. Pellentesque ut vestibulum neque, et malesuada nibh. Pellentesque mi dui, gravida et gravida at, accumsan nec lorem. Nunc id lacinia urna. Sed sed arcu justo.</p>
            </v-flex>
          </v-layout>
        </transition>
        <transition name="fadeY" mode="out-in">
          <v-layout row wrap py-5 v-if="alliancePartners">
            <v-flex xs12>
              <h2>Alliance Partners</h2>
            </v-flex>
            <v-flex md12 xs12>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed enim mauris, luctus a justo sed, viverra bibendum nisl. Pellentesque facilisis dolor eget facilisis consequat. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. In ultricies, ligula vel eleifend tristique, justo massa scelerisque sapien, eu dictum risus leo in nisi. Morbi odio ante, sollicitudin sed finibus vel, bibendum id magna. Phasellus suscipit fringilla neque, id sollicitudin odio tincidunt ac. Curabitur vel interdum neque. Sed ornare mi diam, at placerat leo mattis quis. Duis rutrum elit nisi, quis pharetra leo maximus non. In hac habitasse platea dictumst. Sed maximus leo est, nec accumsan tellus fringilla a. Nulla tincidunt dui imperdiet ultrices porttitor. Pellentesque ut vestibulum neque, et malesuada nibh. Pellentesque mi dui, gravida et gravida at, accumsan nec lorem. Nunc id lacinia urna. Sed sed arcu justo.</p>
            </v-flex>
          </v-layout>
        </transition>
      </v-card-text>
    </v-card>
  </div>
</template>

<style scoped>
.v-toolbar__title {
  color: #2a3997 !important;
}
.title {
  text-transform: uppercase;
  font-size: 64px !important;
  color: #000;
  font-weight: 100;
}
.title span {
  font-weight: 900;
}
h2 {
  font-size: 30px;
  padding-bottom: 15px;
}
p {
  font-size: 15px;
  line-height: 20px;
  margin-bottom: 10px;
  color: #333;
}

.content-img {
  -webkit-box-shadow: 0 5px 20px 0 rgba(54, 57, 73, 0.09);
  box-shadow: 0 5px 20px 0 rgba(54, 57, 73, 0.09);
}
.logo-inner {
  align-items: center;
}
.nav-listing {
  list-style: none;
  display: flex;
  flex-direction: row;
}
.nav-listing li {
  margin-left: 10px;
}
.nav-listing li a {
  text-decoration: none;
  padding: 10px 15px;
  transition: all ease-in-out 0.2s;
  color: #475055;
  font-size: 16px;
}
.nav-listing li a:hover,
.nav-listing li a.active {
  color: #4385f3;
}
.inner-content {
  padding: 70px;
}

.icon-triggers {
  list-style: none;
  margin: 0;
  padding: 30px 0 0 0;
}
.icon-triggers li {
  position: relative;
  cursor: pointer;
  display: inline-block;
  color: #ff7a00;
  border: 3px solid #ff7a00;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  line-height: 0;
  padding: 1.9em;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
  width: 120px;
  height: 120px;
  margin-right: 8%;
  animation: categoryTriggerPulse 3s infinite;
}

.icon-triggers li:before,
.icon-triggers li:after {
  content: "";
  display: block;
  position: absolute;
  width: 120%;
  height: 120%;
  top: -10%;
  left: -10%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  opacity: 0;
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
}

.icon-triggers li:before {
  border: 2px solid #ff7a00;
}

.icon-triggers li.active,
.icon-triggers li:hover {
  background-color: rgb(255, 122, 0);
  color: #fff;

  animation: none;
}
.icon-triggers path {
  transition: all ease-in-out 0.6s;
}
.icon-triggers li path,
.icon-triggers li path {
  fill: rgb(255, 122, 0);
}

.icon-triggers li.active path,
.icon-triggers li:hover path {
  fill: #fff;
}

.icon-triggers li.active:hover {
  cursor: default;
}

.icon-triggers li:not(.active):hover:before {
  border-top-color: #ff7a00;
  border-right-color: #ff7a00;
  border-bottom-color: #ff7a00;
  -webkit-transition: border-top-color 0.15s linear,
    border-right-color 0.15s linear 0.1s, border-bottom-color 0.15s linear 0.2s;
  transition: border-top-color 0.15s linear,
    border-right-color 0.15s linear 0.1s, border-bottom-color 0.15s linear 0.2s;
}

.icon-triggers li:not(.active):hover:after {
  border-top: 3px solid #ff7a00;
  border-left-width: 2px;
  border-right-width: 2px;
  -webkit-transform: rotate(540deg);
  -ms-transform: rotate(540deg);
  transform: rotate(540deg);
  -webkit-transition: border-left-width 0s linear 0.35s,
    -webkit-transform 0.4s linear 0s;
  transition: border-left-width 0s linear 0.35s,
    -webkit-transform 0.4s linear 0s;
  transition: transform 0.4s linear 0s, border-left-width 0s linear 0.35s;
  transition: transform 0.4s linear 0s, border-left-width 0s linear 0.35s,
    -webkit-transform 0.4s linear 0s;
}

.icon-triggers li:hover:after {
  opacity: 1;
}

@-webkit-keyframes categoryTriggerPulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgb(255, 122, 0, 0.8);
  }
  50% {
    -webkit-box-shadow: 0 0 0 15px rgba(255, 122, 0, 0);
  }
  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(255, 122, 0, 0);
  }
}

@keyframes categoryTriggerPulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(255, 122, 0, 0.8);
    box-shadow: 0 0 0 0 rgba(255, 122, 0, 0.8);
  }
  50% {
    -moz-box-shadow: 0 0 0 15px rgba(255, 122, 0, 0);
    box-shadow: 0 0 0 15px rgba(255, 122, 0, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(255, 122, 0, 0);
    box-shadow: 0 0 0 0 rgba(255, 122, 0, 0);
  }
}

.standard-listing {
  color: #ff7a00;
}
.standard-listing li {
  float: left;
  width: 50%;
}
</style>

<script>
import JobDetails from "./JobDetails.ts";
export default JobDetails;
</script>